



















import Vue from 'vue'
import { camelizeKeys } from '@/utils'

import ItemFactory from '../../elements/likert/ItemFactory'
import SurveyMixin from '../SurveyMixin'
import Instruction from '@/survey/elements/Instruction.vue'

const settings = camelizeKeys(require('./counselingQuestions.yml'))
const factory = new ItemFactory(settings)

export default Vue.extend({
  components: { Instruction },
  mixins: [SurveyMixin],
  data() {
    return {
      settings,
      items1Til8: factory.scanRange(1, 8),
    }
  },
})
